import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

const checkoutLineItemsRemoveMutation = ({ country }) => (
	`mutation ($checkoutId: ID!, $lineItemIds: [ID!]!) @inContext(country: ${country}) {
		checkoutLineItemsRemove(checkoutId: $checkoutId, lineItemIds: $lineItemIds) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutLineItemsRemoveMutation;
